import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuditLogsPaged } from "@/common/artemis-operations/audit";
import {
	AuditTable,
	auditTableListProps,
} from "@/components/audit/audit-table";
import { BaseContainer, BasePageContainer } from "@/components/base";
import { useActions } from "@/contexts/actions-context";
import { usePageTitle } from "@/contexts/page-title-context";

export const Route = createFileRoute(
	"/_authenticated/$orgSlug/workspaces/$workspaceId/audit/",
)({ component: WorkspaceAudit });

function WorkspaceAudit() {
	const { workspaceId } = Route.useParams();
	const { setTitle } = usePageTitle();
	const { setActions } = useActions();

	// Scoped to this workspace via the `workspaceId` query arg — this is the backend authorization
	// boundary, not just a display filter.
	const list = useAuditLogsPaged(workspaceId);

	useEffect(() => {
		setTitle("Audit log");
		setActions([]);
		return () => setActions([]);
	}, [setTitle, setActions]);

	return (
		<BasePageContainer>
			<BaseContainer>
				<AuditTable {...auditTableListProps(list)} hideWorkspaceFilter />
			</BaseContainer>
		</BasePageContainer>
	);
}
